export const I18N_BASE_PATH = 'PortfolioEditorBuilder.Content.PlanningAnalysis';
